import { InvitationsInboxPageContent } from "Components/Invitations/InvitationsInboxPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const PAGE_RESOURCES = Resources.Pages.Titles;

export const InvitationsInboxPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(PAGE_RESOURCES.Invitations)}
      backNavigation={{ mode: "historyStack", fallbackUrl: appUrl("homepage") }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <InvitationsInboxPageContent />
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
